$(function() {
    if (!$(".culture").length) {
        return
    }
    var $scrollArea = $("#scrollarea"), 
    $culture = $("#culture"), 
    $sections = $(".culture-section"), 
    $intro = $("#intro"), 
    $dpeth2 = $("#gnb-bg"), 
    $introContent = $intro.find(".culture-intro-content"), 
    $introOverlay = $intro.find(".culture-intro-overlay"), 
    $introVideo = $intro.find(".culture-intro-video"), 
    $introImg = $intro.find(".culture-intro-img"), 
    $introVideoPlayer, 
    $concept = $("#concept"), 
    $conceptSections = 
    $concept.find(".culture-concept-section"), 
    $conceptSectionsText = $conceptSections.children(), 
    isSupportFlash = swfobject.getFlashPlayerVersion().major >= 10, 
    introPlayer, 
    layoutMode = false, startSection = History.getHash(), 
    currentSection, 
    isHashChangedIn = false, 
    isNavigating = false, 
    isHistory = !(document.documentMode && document.documentMode <= 9), 
    isHistory = false, 
    flowMode = Modernizr.touch || (document.documentMode && document.documentMode <= 8), 
    winHeight = SWS.$win.height(), 
    headerHeight, 
    introHeight, 
    contentHeight, 
    conceptHeight, 
    scrollMotion;
    function onIntroReady(player) {
        introPlayer = player;
        $introVideoPlayer = $(player).parent();
        if (!isSupportFlash) {
            $introVideoPlayer.addClass("is-loaded")
        }
        if (layoutMode) {
            resize()
        }
    }
    function onIntroStateChange(state) {
        if (state === 1) {
            $introVideoPlayer.addClass("is-loaded")
        }
    }
    function resize() {
        if (!layoutMode) {
            return
        }
        log("[culture] resize()");
        headerHeight = SWS.$header.height();
        winHeight = SWS.$win.height();
        introHeight = winHeight - headerHeight;
        contentHeight = $culture.outerHeight();
        $scrollArea.height(winHeight + contentHeight + parseFloat(SWS.$footer.outerHeight(true)));
        $intro.css("top", headerHeight);
        $introContent.height(introHeight);
        if (flowMode) {
            $culture.css("margin-top", winHeight)
        }
        var hDiff = (introHeight - $introVideo.outerHeight()) / 2;
        if (hDiff < 0) {
            $introVideo.css({
                position: "",
                left: "",
                top: hDiff
            });
            if ($introVideoPlayer) {
                $introVideoPlayer.css({
                    left: "",
                    width: ""
                })
            }
        } else {
            var winWidth = SWS.$win.width()
              , videoWidth = 16 / 9 * introHeight
              , vDiff = (winWidth - videoWidth) / 2;
            // $introVideo.css("position", "static");
            if ($introVideoPlayer) {
                $introVideoPlayer.css({
                    left: vDiff,
                    width: videoWidth
                })
            }
        }
        var hDiffImg = (introHeight - $introImg.height()) / 2;
        if (hDiffImg < 0) {
            $introImg.css({
                left: "",
                top: hDiffImg,
                width: ""
            })
        } else {
            var winWidth = SWS.$win.width()
              , imgWidth = 768 / 432 * introHeight
              , vDiffImg = (winWidth - imgWidth) / 2;
            $introImg.css({
                left: vDiffImg,
                top: "",
                width: imgWidth
            })
        }
        $conceptSections.height(introHeight).eq(1).css("margin-top", introHeight);
        conceptHeight = $concept.height();
        setTimeout(winScroll, 10);
        // console.log(
        // 'winHeight::', winHeight = SWS.$win.height(), 
        // 'headerHeight::', headerHeight, 
        // 'introHeight::', introHeight, 
        // 'contentHeight::', contentHeight, 
        // 'conceptHeight::', conceptHeight, 
        // 'scrollMotion::', scrollMotion, 
        // 'SWS::', SWS);
    }
    function winScroll() {
        if (!layoutMode) {
            return
        }
        log("[culture] window scroll", SWS.$win.scrollTop());
        var scrollTop = SWS.$win.scrollTop(), _currentSection;
        if (!flowMode) {
            scrollMotion = new TweenMax.to($culture,1,{
                _y: -scrollTop,
                y: -scrollTop,
                ease: Power3.easeOut,
                onUpdateParams: ["{self}"],
                onUpdate: scroll
            })
        } else {
            $culture[0]._y = -scrollTop;
            scroll()
        }
        if (isNavigating || startSection) {
            return
        }
        $sections.each(function(idx, el) {
            var $el = $(el)
              , pos = $el.position().top
              , posData = $el.data("pos");
            if ($.isNumeric(posData)) {
                pos = posData
            } else {
                if (posData) {
                    pos = eval("pos" + posData)
                }
            }
            if (scrollTop >= pos) {
                _currentSection = $el.attr("id");
                log(_currentSection)
            } else {
                return false
            }
        });
        if (_currentSection !== currentSection) {
            currentSection = _currentSection;
            log("[culture] section changed from scroll", currentSection);
            isHashChangedIn = true;
            if (isHistory) {
                History.pushState(null, null, "#" + currentSection)
            } else {
                hashChange(null, currentSection)
            }
        }
    }
    function scroll() {
        var scrollTop = -$culture[0]._y;
        if (scrollTop > (conceptHeight + headerHeight)) {
            if ($dpeth2.hasClass('is-active')) {
                TweenMax.set(SWS.$header, {
                    y: -(headerHeight + $dpeth2.height())
                });
            } else {
                TweenMax.set(SWS.$header, {
                    y: -headerHeight
                })
            }
        } else {
            if (scrollTop > conceptHeight) {
                TweenMax.set(SWS.$header, {
                    y: -(scrollTop - conceptHeight - 1)
                })
            } else {
                TweenMax.set(SWS.$header, {
                    clearProps: "all"
                })
            }
        }
        if (flowMode) {
            if (scrollTop >= (conceptHeight + winHeight)) {
                TweenMax.set($intro, {
                    y: -winHeight
                })
            } else {
                if (scrollTop >= (conceptHeight)) {
                    TweenMax.set($intro, {
                        y: -(scrollTop - conceptHeight)
                    })
                } else {
                    TweenMax.set($intro, {
                        y: 0
                    })
                }
            }
            return
        }
        if (scrollTop < (conceptHeight)) {
            TweenMax.set($introContent, {
                y: 0
            });
            TweenMax.set($introOverlay, {
                y: -scrollTop,
                autoAlpha: Math.max(1 - (scrollTop / 0.3 / introHeight), 0)
            })
        } else {
            TweenMax.set($introContent, {
                y: -(scrollTop - conceptHeight)
            });
            TweenMax.set($introOverlay, {
                y: -introHeight,
                autoAlpha: 0
            })
        }
        SWS.$footer.css("z-index", 100);
        if (scrollTop < contentHeight) {
            SWS.$footer.removeClass("is-fixed");
            TweenMax.set(SWS.$footer, {
                clearProps: "all"
            })
        } else {
            SWS.$footer.addClass("is-fixed");
            TweenMax.set(SWS.$footer, {
                y: contentHeight - scrollTop + SWS.$footer.outerHeight(true)
            })
        }
        $conceptSectionsText.each(function(idx, el) {
            var $el = $(el)
              , $parent = $el.parent()
              , pos = introHeight + $parent.position().top + parseFloat($parent.css("margin-top"));
            TweenMax.set($el, {
                y: ((scrollTop - pos) / introHeight * (introHeight * 0.3))
            })
        })
    }
    function moveTo(id, isNotPush) {
        log("[culture] moveTo", id, isNotPush);
        var $target = $("#" + id)
          , targetPos = $target.position().top
          , posData = $target.data("pos");
        if ($.isNumeric(posData)) {
            targetPos = posData
        } else {
            if (posData) {
                targetPos = eval("targetPos" + posData)
            }
        }
        currentSection = id;
        isNavigating = true;
        isHashChangedIn = true;
        if (!isNotPush) {
            if (isHistory) {
                History.pushState(null, null, "#" + currentSection)
            } else {
                hashChange(null, currentSection)
            }
            if (startSection) {
                History.Adapter.trigger(window, "anchorchange")
            }
        }
        $("html, body").stop(true).animate({
            scrollTop: targetPos
        }, 1000, "easeInOutCubic", function() {
            isNavigating = false
        })
    }
    
    function artists() {
        var $artists = $("#artists")
          , $list = $artists.find(".culture-artists-list")
          , $links = $list.find(".culture-artists-link")
          , $detailTmpl = $artists.find("#culture-artists-detail").remove().clone().removeAttr("id")
          , col = 3;
        $detailTmpl.find(".culture-artists-detail-close").on("click", function(event) {
            $(this).parent().parent().stop(true).slideUp(500, "easeOutExpo", function() {
                $(this).remove();
                resize()
            });
            event.preventDefault()
        });
        $links.on("click", function(event) {
            var $this = $(this)
              , $remain = $artists.find(".culture-artists-detail")
              , $detail = $detailTmpl.clone(true)
              , $detailContent = $($this.attr("href")).clone().prependTo($detail.find(".culture-artists-detail-inner"))
              , $rowEnd = $this;
            function open() {
                var index = $links.index($this), scrollTo = $list.offset().top, itemHeight = $links.parent().outerHeight(), isSliderInit = false, imgSlider, $imgList = $detailContent.find(".culture-slider-img");
                if (layoutMode) {
                    var row = Math.ceil((index + 1) / col) - 1
                      , rowStart = row * col
                      , rowEnd = rowStart + col;
                    $rowEnd = $links.slice(rowStart, rowEnd).last();
                    scrollTo += (itemHeight * row)
                } else {
                    scrollTo += (itemHeight * index)
                }
                $detail.insertAfter($rowEnd.parent()).stop(true).slideDown({
                    duration: 1000,
                    easing: "easeOutCubic",
                    step: function() {
                        if (isSliderInit) {
                            return
                        }
                        $imgList.children().css("display", "block");
                        if ($imgList.find("li").length > 1) {
                            imgSlider = $imgList.bxSlider({
                                pager: false,
                                prevText: "",
                                nextText: "",
                                onSliderLoad: function() {
                                    var $dir = $imgList.parents(".bx-wrapper").eq(0).find(".bx-controls-direction > a");
                                    $dir.filter(".bx-prev").addClass("slide-prev").append('<i class="icon-arr-left-big"></i><span class="blind">Prev</span>');
                                    $dir.filter(".bx-next").addClass("slide-next").append('<i class="icon-arr-right-big"></i><span class="blind">Next</span>')
                                }
                            })
                        }
                        isSliderInit = true
                    },
                    complete: function() {
                        resize()
                    }
                });
                $("html, body").stop(true).animate({
                    scrollTop: scrollTo
                }, 700, "easeOutCubic")
            }

            $this.find(".culture-artists-title").clone().prependTo($detailContent.find(".culture-artists-detail-text"));
            if ($remain.length) {
                $remain.stop(true).slideUp(500, "easeOutExpo", function() {
                    $(this).remove();
                    open()
                })
            } else {
                open()
            }
            event.preventDefault()
        })
    }

    // 2019-10-01 수정 | setAccordion 추가
    function setListAccordion(queryStr) {
        var $accordionObj = $(queryStr);
        $accordionObj.each(function(i, el){
            $obj = $(this);
            $list = $obj.find(".culture-artists-list");
            $links = $list.find(".culture-artists-link");
            $detailTmpl = $obj.find("#culture-artists-detail").remove().clone().removeAttr("id");
            col = 3;
            $detailTmpl.find(".culture-artists-detail-close").on("click", function(event) {
                $(this).parent().parent().stop(true).slideUp(500, "easeOutExpo", function() {
                    $(this).remove();
                    resize()
                });
                event.preventDefault()
            });
            $links.on("click", function(event) {
                var $this = $(this)
                , $remain = $obj.find(".culture-artists-detail")
                , $detail = $detailTmpl.clone(true)
                , $detailContent = $($this.attr("href")).clone().prependTo($detail.find(".culture-artists-detail-inner"))
                , $rowEnd = $this;
                function open() {
                    var index = $links.index($this), scrollTo = $list.offset().top, itemHeight = $links.parent().outerHeight(), isSliderInit = false, imgSlider, $imgList = $detailContent.find(".culture-slider-img");
                    if (layoutMode) {
                        var row = Math.ceil((index + 1) / col) - 1
                        , rowStart = row * col
                        , rowEnd = rowStart + col;
                        $rowEnd = $links.slice(rowStart, rowEnd).last();
                        scrollTo += (itemHeight * row)
                    } else {
                        scrollTo += (itemHeight * index)
                    }
                    $detail.insertAfter($rowEnd.parent()).stop(true).slideDown({
                        duration: 1000,
                        easing: "easeOutCubic",
                        step: function() {
                            if (isSliderInit) {
                                return
                            }
                            $imgList.children().css("display", "block");
                            if ($imgList.find("li").length > 1) {
                                imgSlider = $imgList.bxSlider({
                                    pager: false,
                                    prevText: "",
                                    nextText: "",
                                    onSliderLoad: function() {
                                        var $dir = $imgList.parents(".bx-wrapper").eq(0).find(".bx-controls-direction > a");
                                        $dir.filter(".bx-prev").addClass("slide-prev").append('<i class="icon-arr-left-big"></i><span class="blind">Prev</span>');
                                        $dir.filter(".bx-next").addClass("slide-next").append('<i class="icon-arr-right-big"></i><span class="blind">Next</span>')
                                    }
                                })
                            }
                            isSliderInit = true
                        },
                        complete: function() {
                            resize()
                        }
                    });
                    $("html, body").stop(true).animate({
                        scrollTop: scrollTo
                    }, 700, "easeOutCubic")
                }

                $this.find(".culture-artists-title").clone().prependTo($detailContent.find(".culture-artists-detail-text"));
                if ($remain.length) {
                    $remain.stop(true).slideUp(500, "easeOutExpo", function() {
                        $(this).remove();
                        open()
                    })
                } else {
                    open()
                }
                event.preventDefault()
            })
        });
    }

    function nav() {
        var $nav = $("#culture-nav"), $links = $nav.find(".culture-nav-link"), $linkText = $links.find(".culture-nav-text"), $current, isFocus = false;
        function navOver() {
            TweenMax.to($nav, 0.5, {
                width: $links.width(),
                ease: Power3.easeInOut
            })
        }
        function navOut() {
            TweenMax.to($nav, 0.7, {
                width: $links.width() - $linkText.width(),
                ease: Power3.easeOut
            })
        }
        $nav.on({
            mouseenter: navOver,
            mouseleave: navOut
        });
        $links.on({
            click: function(event) {
                log("[culture] nav link clicked", $(this).text());
                var $this = $(this)
                  , href = $this.attr("href")
                  , $target = $(href);
                $current = $this;
                if (!$target.length) {
                    return
                }
                moveTo(href.substr(1));
                event.preventDefault()
            },
            mouseenter: function() {
                $current = $links.filter(".is-current");
                $current.removeClass("is-current")
            },
            mouseleave: function() {
                $current.addClass("is-current")
            },
            focusin: function() {
                isFocus = true;
                navOver()
            },
            focusout: function() {
                setTimeout(function() {
                    if (!isFocus) {
                        navOut()
                    }
                    isFocus = false
                }, 1)
            }
        });
        $nav.width($links.width() - $linkText.width());
        SWS.$win.on("resize.cultureNav", function() {
            $nav.css("margin-top", -$nav.height() / 2)
        }).resize();
        $nav.addClass("is-loaded")
    }
    function hashChange(arg, target) {
        var hash = arg ? History.getHash() : target;
        log("[culture] History anchorchange", hash, isHashChangedIn);
        $(".culture-nav-link").removeClass("is-current").filter('[href="#' + hash + '"]').addClass("is-current");
        if (!isHashChangedIn) {
            moveTo(hash, true)
        }
        isHashChangedIn = false
    }
    function init() {
        switchLayout("culture", function() {
            return $intro.css("z-index") != 2
        }, function(state) {
            layoutMode = state;
            if (state) {
                $culture[0]._y = 0;
                SWS.$header.addClass("is-fixed");
                SWS.$win.on({
                    load: function() {
                        resize();
                        setTimeout(function() {
                            resize();
                            if (startSection) {
                                moveTo(startSection);
                                startSection = undefined
                            }
                        }, 10)
                    },
                    "resize.cultureIntro": resize,
                    "scroll.cultureIntro": winScroll
                });
                resize()
            } else {
                startSection = undefined;
                SWS.$win.off("resize.cultureIntro");
                SWS.$win.off("scroll.cultureIntro");
                SWS.$header.removeClass("is-fixed");
                SWS.$footer.removeClass("is-fixed");
                TweenMax.killAll();
                TweenMax.set(SWS.$header, {
                    clearProps: "all"
                });
                TweenMax.set($culture, {
                    clearProps: "all"
                });
                TweenMax.set($intro, {
                    clearProps: "all"
                });
                TweenMax.set($introContent, {
                    clearProps: "all"
                });
                TweenMax.set($introOverlay, {
                    clearProps: "all"
                });
                TweenMax.set($introImg, {
                    clearProps: "all"
                })
            }
        });
        nav();
        History.Adapter.on(window, "anchorchange", hashChange);
        if (!flowMode) {
            if (isSupportFlash) {
                $(".culture-intro-movie").ytchromeless({
                    videoWidth: "100%",
                    videoHeight: "100%",
                    autoplay: true,
                    mute: true,
                    start: parseInt($(".culture-intro-movie").data("start")),
                    end: parseInt($(".culture-intro-movie").data("end")),
                    loop: true,
                    onReady: onIntroReady,
                    onStateChange: onIntroStateChange
                })
            } else {
                $(".culture-intro-movie").ytiframe({
                    videoWidth: "100%",
                    videoHeight: "auto",
                    autoplay: 1,
                    controls: 0,
                    onReady: onIntroReady
                })
            }
        }
        $(".culture-sketch-movie").on("click", function(event) {
            $(this).ytiframe({
                videoWidth: "100%",
                videoHeight: "auto",
                autoplay: 1
            });
            event.preventDefault()
        });
        // 2019-10-01 수정
        artists();
        setListAccordion("#work");

        $(".culture-backstage-teaser").on("click", function(event) {
            $(this).ytiframe({
                videoWidth: "100%",
                videoHeight: "auto",
                autoplay: 1
            });
            event.preventDefault()
        });
        
        $(".culture-backstage .culture-slider-img").each(function(idx, el) {
            var $el = $(el);
            $el.children().css("display", "block");
            if ($el.find("li").length > 1) {
                $el.bxSlider({
                    prevText: "",
                    nextText: "",
                    onSliderLoad: function() {    
                        var $dir = $el.parents(".bx-wrapper").eq(0).find(".bx-controls-direction > a");
                        $dir.filter(".bx-prev").addClass("slide-prev").append('<i class="icon-arr-left-big"></i><span class="blind">Prev</span>');
                        $dir.filter(".bx-next").addClass("slide-next").append('<i class="icon-arr-right-big"></i><span class="blind">Next</span>')
                    }
                })
            }
        })
    }
    init()
});
